import type { ReactElement } from 'react'

import { Box, Text, zIndex } from '@factorialco/deprecated-design-system'

import Portal from 'modules/core/components/Portal'

import Header from 'modules/layout/components/Page/Header'

interface Props {
  onClose: () => void
  fileName: string
  content: ReactElement
}

const Preview = ({ onClose, fileName, content }: Props) => {
  return (
    <Portal onClose={onClose}>
      <Box
        width="full"
        height="full"
        background="grey000White"
        style={{
          position: 'fixed',
          top: '0',
          left: '0',
          zIndex: zIndex.modals,
        }}
      >
        <Header onClose={onClose}>
          <Text.Header1 color="grey800">{fileName}</Text.Header1>
        </Header>
        <Box flexDirection="row" style={{ flex: '1 1 auto' }}>
          <Box overflowX="auto" background="grey200" style={{ flex: '1 1 auto' }}>
            <Box flexGrow alignItems="center" justifyContent="center">
              {content}
            </Box>
          </Box>
        </Box>
      </Box>
    </Portal>
  )
}

export default Preview
